import React, { useState, useEffect } from "react";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { useNavigate } from "react-router";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { MdDeleteForever } from "react-icons/md";

// Import the sound file
// import matchStartSound from "../../certificates/IPL_TUNE.mp3";
import startMatch from "../../certificates/startMatch.mp3";

const ShowteamPage = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [soundPlayed, setSoundPlayed] = useState(false);

  const tableHead = ["Sr.", "Name", "Win Team Name", "Status", "Action"];

  useEffect(() => {
    performRequest("GET", getFilteredURL("/match/matches", page))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.allData);
          setTotalPages(Math.ceil(res.data?.matchCount / 50));
        } else {
          Toast("error", "Error while fetching matches");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [page]);

  const deleteMatch = (id) => {
    performRequest("DELETE", `/match/delete/${id}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Match deleted successfully");
          setData((prevMatches) =>
            prevMatches.filter((match) => match.id !== id)
          );
        } else {
          Toast("error", "Error while deleting match");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const handleStartMatch = (id) => {
    if (!soundPlayed) {
      const audio = new Audio(startMatch);
      audio.play();
      setSoundPlayed(true);
    }
    navigate(`/view-match/${id}`);
  };

  return (
    <>
      <div className="container mt-4">
        <h2 className="text-center mb-4">🏏 All Cricket Matches</h2>
        <div className="col-md-12 col-sm-12 py-2 m-auto">
          <div className="card">
            <div className="table-responsive">
              <table className="table table-vcenter">
                <thead>
                  <tr>
                    {tableHead?.map((item, index) => (
                      <th key={index}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => {
                    const index1 = (page - 1) * 50 + (index + 1); // Adjust Sr. No.
                    return (
                      <tr key={item?.id}>
                        <td>{index1}</td>
                        <td>{` Match ${item?.id}` || "N/A"}</td>
                        <td>{item?.result || "N/A"}</td>
                        <td>
                          {item.Matchstatus === "Completed" ? (
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "#ffa500",
                                color: "white",
                              }}
                            >
                              Completed
                            </button>
                          ) : (
                            <>
                              <button
                                className="btn btn-success"
                                onClick={() => handleStartMatch(item.id)}
                              >
                                Start the match
                              </button>
                            </>
                          )}
                        </td>
                        <td>
                          <div
                            className="btn btn-white"
                            onClick={() => deleteMatch(item.id)}
                          >
                            <MdDeleteForever style={{ fontSize: "20px" }} />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mb-4">
            {/* Corrected Pagination */}
            <Pagination
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              showPage={showPage}
              setShowPage={setShowPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowteamPage;
